module.exports = __webpack_public_path__ + "img/40_69_007_320.6a808118.jpg";